import { Tooltip } from '@material-ui/core'

import { showNotification } from 'store/notification/actionCreator'

import {
  getVendorEmailsById,
  setOrderSamplesFrom,
  setSampleData,
} from 'store/order/actionCreator'
import { DATE_FORMAT, getDisplayImage } from 'util/CommonUtils'
import { isEmpty, isNull, isUndefined } from 'lodash'
import moment from 'moment'

export const formatVirtualBundleData = (data) => {
  if (!data || !Array.isArray(data)) {
    return []
  }
  data.forEach((group) => {
    group.department = group?.department
    group.class = group?.class_name
    group.vendorId = group?.vendor_id
    group.vendorName = group?.vendor_name
    group.brand = group?.brand || ''
    group.vbName = group?.vb_name || ''
    group.vbParentTcin = group?.vb_parent_tcin || ''
    group.vbItemsCount = group?.vb_items_count || 0
    group.childTcinQtyMap = group?.child_tcin_qty_map || {}
    group.childTcins = group?.child_tcins || ''
    group.childTcinSamplesReqTotalQty =
      group?.child_tcin_samples_req_total_qty || Number(0)
    group.mvt = group.mvt || ''
    group.vbState = group?.vb_state || ''
    group.kitType = group?.kit_type || ''
    group.isMerchantApprovedForPublishing =
      group?.is_merchant_approved_for_publishing === true ? 'Yes' : 'No'
    group.launchDate = group.launch_date
      ? moment(group.launch_date).format(DATE_FORMAT)
      : ''
    group.imageUrl = group?.image_url
      ? getDisplayImage(`${group?.image_base_url}${group?.image_url}`, 50, 50)
      : 'Image Not Found'
  })
  return data
}
const getDescription = (description) => {
  if (!description) return ''
  const trimmedDescription =
    description.length > 120 ? description.slice(0, 120) + '...' : description
  return description.length > 120 ? (
    <Tooltip title={description} arrow placement="top">
      <span style={{ cursor: 'pointer' }}>{trimmedDescription}</span>
    </Tooltip>
  ) : (
    <span>{description}</span>
  )
}
export const getFieldValue = (
  field,
  item,
  vbName = '',
  dispatch,
  auth = {}
) => {
  if (field.label === '#Samples') {
    return item?.samples.length
  }
  if (field.label === 'Description' || field.label === 'description') {
    return getDescription(item[field.value])
  }
  if (field.label === 'Image' || field.label === 'image') {
    return getDisplayImage(item[field.value], 50, 50)
  }
  if (field.label === 'Owned Brand') {
    return item[field.value] ? 'Yes' : 'No'
  }
  if (field.label === 'Parent Name') {
    return vbName || item[field.value]
  }
  return item[field.value]
}

export const getFormattedData = (
  virtualBundlesFromItems = [],
  virtualBundlesFromSearch = [],
  VirtualBundlesProjectId = ''
) => {
  const VBSample = virtualBundlesFromSearch.filter((sample) => {
    if (isEmpty(sample?.collections)) return true
    return sample.collections.some(
      (collection) => collection?.id === VirtualBundlesProjectId
    )
  })
  return virtualBundlesFromItems.map((item) => ({
    ...item,
    samples: VBSample.filter((sample) => sample?.tcin === item?.tcin) || [],
  }))
}

export const setOrderItems = (e, item = {}, dispatch, auth = {}) => {
  const { session: { userInfo: { lanId = '' } = {} } = {} } = auth
  let vendorIdEmpty = []
  const {
    vbParentTcin = '',
    quantity = Number(1),
    ship_to_location = '',
  } = item
  if (ship_to_location) {
    item = Object.assign({}, item, { shipTo: ship_to_location })
  }
  if (isNull(item.vendorId) || isUndefined(item.vendorId)) {
    vendorIdEmpty.push(item)
  }
  const newSelected = [
    {
      ...item,
      vendorEmail: '',
      emailVmm: null,
      vendorBPIds: '',
      bpidsVmm: null,
      studioNotes: '',
      vendorNotes: '',
      userId: lanId,
      virtualBundleParent: vbParentTcin,
      project: '',
      quantity,
    },
  ]
  if (isEmpty(vendorIdEmpty)) {
    dispatch(setOrderSamplesFrom(window.location.pathname))
    dispatch(setSampleData(newSelected))
    dispatch(getVendorEmailsById(item.vendorId))
  } else {
    dispatch(setOrderSamplesFrom(''))
    dispatch(
      showNotification(
        true,
        `Some of the samples selected have no vendor Id`,
        'error'
      )
    )
  }
}
